// expo-haptics has no web build. Only reachable via SliderField.tsx's
// `Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light)` call, which is
// itself `!IS_WEB`-guarded and never actually runs on web — this only needs
// to exist so the static import resolves.
export const impactAsync = async () => undefined
export const ImpactFeedbackStyle = { Light: 'light', Medium: 'medium', Heavy: 'heavy' }
